import { createSlice } from '@reduxjs/toolkit'
import { fetchPosts, fetchUsers } from '../../asyncs/UserAsyncs'


export const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: [],
    posts: [],
    status: "",
  },
  reducers: {
    getAllUser: (state, action) => {
      state.data = action.payload
    },
    getAllPosts: (state, action) => {
      state.data = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUsers.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.data = action.payload
        state.status = 'idle'
      })
      .addCase(fetchPosts.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.posts = action.payload
        state.status = 'idle'
      })
  }
})

export const { getAllUser, getAllPosts, setError } = userSlice.actions

export default userSlice.reducer